<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="row">
        <div class="col-12 pt-2 pb-3 pl-4">
          <h3><i class="fas fa-map-marked-alt"></i> Módulo de Visitas <small style="font-size: 18px;">| Registrar Check-in</small></h3>
          <small>Acompanhe, planeje e registre suas visitas.</small>
        </div>
      </div>
      <div class="row pt-4 pb-3">
        <div class="col-12">
          <Forms ref="frmGroup"
            :title="'REGISTRAR CHECK-IN'"
            :showClearButton="true"
            :showSaveButton="true"
            :showBackButton="true"
            v-on:Clear="onClear"
            v-on:Back="onBack"
            v-on:Save="onSave">
            <div class="form-group row">
            <div class="col-md-12">
              <label><small class="text-danger" v-if="form.documento.required">*</small> CPF/CNPJ:</label>
              <div class="input-group">
                <b-form-input type="text"
                              ref="documento"
                              :placeholder="'Digite o CPF ou CNPJ do Contato'"
                              v-model="form.documento.value"
                              :size="form.documento.maxlength"
                              :required="form.documento.required"
                              :state="form.documento.state"
                              v-mask="['###.###.###-##', '##.###.###/####-##']"
                              @blur="onSearchPessoaByDocument"></b-form-input>
                <span class="input-group-addon" @click="onSearchPessoaByDocument"><i class="fa fa-search"></i></span>
              </div>
            </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <label><small class="text-danger" v-if="form.documento.required">*</small> Nome:</label>
                <div class="input-group flex-nowrap">
                  <span class="input-group-addon"><i class="fa fa-user"></i></span>
                  <v-select
                    label="text"
                    @input="onSelectPessoaByName"
                    @search="onSearchPessoaByName"
                    v-model="form.name.selected"
                    :options="form.name.options"
                    :placeholder="'Digite o Nome do Contato'"
                    :required="form.name.required"
                    :state="form.name.state"
                  >
                    <template v-slot:no-options>Nenhum lead encontrado.</template>
                  </v-select>
                </div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <label><small class="text-danger" v-if="form.email.required">*</small> Email:</label>
                <div class="input-group">
                  <span class="input-group-addon"><i class="fas fa-envelope"></i></span>
                  <b-form-input disabled
                                type="text"
                                :placeholder="'Digite o E-mail do Contato'"
                                v-model="form.email.value"
                                :size="form.email.maxlength"
                                :required="form.email.required"
                                :state="form.email.state"></b-form-input>
                </div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <label ><small class="text-danger">*</small> Local:</label>
                <div class="input-group" style="border: solid 1px #d6d6d6">
                  <Map
                    v-if="data.deslocamentoId !== null"
                    ref="map"
                    style="width: 100%; height: 400px;"
                    @initialized="onInitialized"
                    @change:location="handleCoords"
                  />
                </div>
              </div>
            </div>
          </Forms>
        </div>
      </div>
      <div class="row mt-5 pt-5">
        <div class="col-12 text-center">
          <img src="/static/img/bg/world_re_768g.svg" style="width: 40%; opacity: 0.2"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'

import DeslocamentoRepository from '@/shared/http/repositories/deslocamento/deslocamento.js'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'

import Map from '../../components/Map.vue'

const form = {
  documento: {
    value: '',
    maxlength: '30',
    required: true,
    state: null
  },
  name: {
    value: null,
    options: [],
    clearOption: true,
    selected: null,
    required: false,
    state: null
  },
  email: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  personId: {
    value: null,
    required: true,
    state: null
  }
}
const data = {
  personId: null,
  deslocamentoId: null,
  latitudeInicial: null,
  longitudeInicial: null,
  kmRodado: null,
  coordsTempoReal: null
}

export default {
  name: 'Checkin',
  mixins: [ActionsForm],
  components: { Map },
  data () {
    return {
      data: data,
      form: form
    }
  },
  async mounted () {
    loading.push()
    Tools.MinimizedSidebar()
    await this.getDeslocamento()
  },
  methods: {
    onBack () {
      this.$router.push({ name: 'Visitas' })
    },
    onInitialized () {
      loading.pop()
    },
    async handleCoords () {
      const currentCoords = await this.$refs.map.getCurrentLocation()
      const kmRodado = await this.getKmRodado(currentCoords)

      this.data.coordsTempoReal = this.data.coordsTempoReal === null
      this.data.latitudeInicial = currentCoords.latitude
      this.data.longitudeInicial = currentCoords.longitude
      this.data.kmRodado = kmRodado
    },
    async getDeslocamento () {
      const response = await DeslocamentoRepository.GetActive()

      if (response.data === '') {
        this.onBack()
        return
      }

      this.data.deslocamentoId = response.data.id
    },
    async getKmRodado (currentCoords) {
      const { data } = await DeslocamentoRepository.GetCoordinates(this.data.deslocamentoId)

      const origin = {
        latitude: data.latitude,
        longitude: data.longitude
      }

      const destination = {
        latitude: currentCoords.latitude,
        longitude: currentCoords.longitude
      }

      const response = await this.$refs.map.getDistance(origin, destination)

      if (!response) {
        toast.error('Não foi possível calcular a distância percorrida. Tente Novamente')
        return
      }

      return response.distance.value
    },
    onSearchPessoaByDocument () {
      if (this.form.documento.value) {
        const document = this.form.documento.value.replace(/[^\d]+/g, '')
        this.getPersonData(document)
      } else {
        toast.info('Atenção! Você precisa informar um CPF ou CNPJ para localizar o associado.')
      }
    },
    onSearchPessoaByName (search) {
      PersonRepository.GetByName(search)
        .then((response) => {
          this.form.name.options = response.data.content.filter((x) => x.id != null).map((x) => ({'value': x.document, 'text': x.nome}))
        })
    },
    onSelectPessoaByName (selected) {
      this.getPersonData(selected.value)
    },
    getPersonData (document) {
      PersonRepository.GetByDocument(document)
        .then((response) => {
          let data = response.data.content

          if (data.length > 0) {
            this.form.personId.value = data[0].id
            this.$nextTick(async () => {
              await this.setFormValues(response.data.content[0])
              this.$forceUpdate()
            })
          } else {
            if (!this.form.name.value) {
              this.form.documento.value = ''
              toast.info('Não foi encontrado uma pessoa com este CPF.')
            }
          }
        })
        .catch((err) => {
          console.error('err', err)
          this.onException(err)
        })
    },
    setFormValues (dataToForm) {
      this.form.documento.value = dataToForm.document
      this.form.name.selected = dataToForm.nome
      this.form.name.value = dataToForm.nome
      this.form.email.value = dataToForm.email
    },
    async onCreate () {
      if (this.data.latitudeInicial === null) {
        toast.error('Geolocalização é necessária para iniciar o deslocamento')
        return
      }

      if (this.data.deslocamentoId === null) {
        toast.error('Não há um deslocamento em andamento para fazer check-in')
        return
      }

      if (!this.data.kmRodado) {
        toast.error('Não foi possível calcular a distância percorrida.')
        return
      }

      try {
        loading.push()
        await DeslocamentoRepository.CheckIn(this.data)

        toast.success(this.$lang.Common.Alerts.Success)
        this.onBack()
      } catch (error) {
        toast.error(this.$lang.Common.Alerts.Error)
      } finally {
        loading.pop()
      }
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 11px;
  box-shadow: 0 0 1em #ccc;
}
h4 {
  font-size: 1.25rem !important;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
</style>

<style>
.v-select{
  flex: 1 1 auto;
  background: #fff url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right .75rem center;
  background-size: 8px 10px;
}

.v-select input{
  padding: 2px 1rem;
  font-size: 13px;
  line-height: 1.25;
  background-clip: padding-box;
  color: #b0bec5;
}

.vs__selected-options{
  color: #607d8b;
}

.v-select > #vs1__combobox {
  height: 35px;
  border-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/deslocamento/register/checkin.vue